export const STEP = {
  select: 'select',
  form: 'form',
  spreadSheet: 'spreadSheet'
};
